<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :export-file-name="priceUtil.getFileName(fileName)"
          :column-defs="columnDefs"
          :row-data="rowDataList"
        />
      </div>
      <div v-if="showRemark" ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" no="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { isNumber } from '@/utils/validate'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import StrUtils from '@/utils/StrUtils'
import URL from '@/api/urlTranslator'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export default {
  name: 'SurchargeFclDataGrid',
  components: {},
  props: {
    configModule: { type: String, default: '22080100' },
    priceNo: { type: String, default: '' },
    showCostOrSell: { type: Boolean, default: false },
    showCost: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showBasicInfo: { type: Boolean, default: true },
    showSelection: { type: Boolean, default: true },
    filter: { type: Object, default: () => {} },
    gridOptions: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] },
    showRemark: { type: Boolean, default: true },
    fileName: { type: String, default: 'SurchargeFCL' }
  },
  data() {
    return {
      priceTypes: PriceConstant.PRICE_ALL_TYPES,
      showLevel: false, // 是否显示运价等级
      txtRemarks: '',
      remarkChange: false,
      authedLevel: 99,
      proxy: {},
      filterJson: {},
      showDetail: false,
      gridParams: {},
      gridApi: null,
      priceUtil: PriceUtils
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    hideCost() {
      return !(!this.showCostOrSell && this.showCost)
    },
    rowDataList() {
      if (this.rowData) {
        for (const data of this.rowData) {
          const params = { value: data.chargeScaleCode, data: data }
          data.chargeScaleCodeString = PriceUtils.chargeScaleCodeLabelFunc(params, this.isZh)
        }
      }
      return this.rowData
    },
    columnDefs() {
      return [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true,
          hide: !this.showSelection, suppressColumnsToolPanel: !this.showSelection,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          hide: !this.showBasicInfo, initialHide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, {
          headerName: this.$t('Pricing.Direct'), field: 'directType', colId: 'directType', width: 200, hide: true,
          cellRenderer: (params) => {
            const result = CommonState.getNameByCode(PriceConstant.DIRECT_TYPE, params.value)
            if (result) {
              return result
            }
            return params.value
          }
        }, {
          headerName: this.$t('Pricing.Via'),
          colId: 'via',
          field: 'via',
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Pricing.TradeLane'), field: 'region', colId: 'region', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
          } },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Pricing.BookingAgent'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          hide: !this.showBasicInfo,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        {
          headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200,
          hide: !this.showBasicInfo
        },
        {
          headerName: this.$t('Pricing.ChargeType'), field: 'chargeType', colId: 'chargeType', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.chargeTypeLabelFunc(params)
          }
        },
        {
          headerName: this.$t('Pricing.FeeName'), field: 'chargeScaleCodeString', colId: 'chargeScaleCodeString', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', params.data.chargeScaleCode, 'zhName')
          }
        },
        {
          headerName: this.$t('Pricing.ChargeUnit'), field: 'unit', colId: 'unit', width: 200,
          cellRenderer: (params) => {
            const result = CommonState.getNameByCode(ChargeMeasure.CHARGE_MEASURES, params.value)
            if (result) {
              return result
            }
            return params.value
          }
        },
        {
          headerName: this.$t('Pricing.VatIncluded'), field: 'isVat', colId: 'isVat', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.COST_VAT'), field: 'costVat', colId: 'costVat', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost
        },
        {
          headerName: '20\'(Cost)', field: 'cost20', colId: 'cost20', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'(Cost)', field: 'cost40', colId: 'cost40', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'HC(Cost)', field: 'costhc', colId: 'costhc', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '45\'(Cost)', field: 'cost45', colId: 'cost45', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '20\'NOR(Cost)', field: 'cost20nor', colId: 'cost20nor', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'NOR(Cost)', field: 'cost40nor', colId: 'cost40nor', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.UnitPrice') + '(Cost)', field: 'costCasePrice', colId: 'costCasePrice', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.SELL_VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost
        },
        {
          headerName: '20\'' + (this.showCost ? '(Sell)' : ''), field: 'sum20', colId: 'sum20', width: 200,
          hide: this.showCostOrSell, suppressColumnsToolPanel: this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'' + (this.showCost ? '(Sell)' : ''), field: 'sum40', colId: 'sum40', width: 200,
          hide: this.showCostOrSell, suppressColumnsToolPanel: this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'HC' + (this.showCost ? '(Sell)' : ''), field: 'sumhc', colId: 'sumhc', width: 200,
          hide: this.showCostOrSell, suppressColumnsToolPanel: this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '45\'' + (this.showCost ? '(Sell)' : ''), field: 'sum45', colId: 'sum45', width: 200,
          hide: this.showCostOrSell, suppressColumnsToolPanel: this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '20\'NOR(Sell)', field: 'sum20nor', colId: 'sum20nor', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'NOR(Sell)', field: 'sum40nor', colId: 'sum40nor', width: 200,
          hide: this.hideCost, suppressColumnsToolPanel: this.hideCost,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.UnitPrice') + (this.showCost ? '(Sell)' : ''), field: 'casePrice', colId: 'casePrice', width: 200,
          hide: this.showCostOrSell, suppressColumnsToolPanel: this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit(params, this.filter.currency)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.vatLabelFunc2(params)
          }
        },
        {
          headerName: '20\'', field: 'sum20', colId: 'sum20_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'', field: 'sum40', colId: 'sum40_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'HC', field: 'sumhc', colId: 'sumhc_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '20\'NOR', field: 'sum20nor', colId: 'sum20nor_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '40\'NOR', field: 'sum40nor', colId: 'sum40nor_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: '45\'', field: 'sum45', colId: 'sum45_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.UnitPrice'), field: 'casePrice', colId: 'casePrice_1', width: 200,
          hide: !this.showCostOrSell, suppressColumnsToolPanel: !this.showCostOrSell,
          cellRenderer: (params) => {
            return PriceUtils.priceByViewColumnLabelFunc_nolimit2(params, this.filter.currency, this.showCost)
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200
        },
        {
          headerName: this.$t('Pricing.PaymentTerm'), field: 'payment', colId: 'payment', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 },
        { headerName: this.$t('Pricing.GenerateCharge'), field: 'generateCharge', colId: 'generateCharge', width: 200,
          cellRenderer: (params) => {
            return params.value ? '√' : ''
          } },
        { headerName: this.$t('Pricing.Dangerous'), field: 'dangerous', colId: 'dangerous', width: 200,
          cellRenderer: (params) => {
            return params.value ? '√' : ''
          } },
        {
          headerName: this.$t('Pricing.DangerousClass'), field: 'dangerousClass', colId: 'dangerousClass', width: 200
        },
        {
          headerName: this.$t('Pricing.Attachment'), field: 'attachment', colId: 'attachment', width: 200,
          cellRenderer: params => {
            return this.fileLabel(params)
          }
        },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        // { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
        //   hide: true,
        //   cellRenderer: (params) => {
        //     return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
        //   },
        //   tooltipValueGetter: (params) => {
        //     return ColumnUtils.userToolTipLabel(params.value)
        //   } },
        { headerName: this.$t('CargoMsg.Cargo_PriceUpdateUser'), field: 'updateUserId', colId: 'updateUserId', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), this.language)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.userToolTipLabel(params.value)
          } },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.priceTypes, params.value)
          }
        }
      ]
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.gridOptions.onRowClicked = this.onRowClickedEvent
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    setCellColor(data) {
      const style = {}
      const cost20 = this.getValue(data.cost20)
      const sum20 = this.getValue(data.sum20)
      const cost40 = this.getValue(data.cost40)
      const sum40 = this.getValue(data.sum40)
      const costhc = this.getValue(data.costhc)
      const sumhc = this.getValue(data.sumhc)
      const cost45 = this.getValue(data.cost45)
      const sum45 = this.getValue(data.sum45)
      const costCasePrice = this.getValue(data.costCasePrice)
      const casePrice = this.getValue(data.casePrice)
      if (cost20 > sum20 || cost40 > sum40 || costhc > sumhc || cost45 > sum45 || costCasePrice > casePrice) {
        style['color'] = 'red'
      }
      return style
    },
    getValue(value) {
      return (value && isNumber(value)) ? value : 0.0
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
      this.txtRemarks = data.remarks
    },
    fileLabel(params) {
      if (!params.data.businessDocuments || params.data.businessDocuments.length === 0) {
        return ''
      }
      const fileIds = Array.from(params.data.businessDocuments, p => p.documentId).reduce((a, b) => a + ',' + b)
      const fileNames = Array.from(params.data.businessDocuments, p => p.fileName).reduce((a, b) => a + ',' + b)
      const fileName = this.priceNo + '.zip'
      return StrUtils.isEmpty(fileIds) ? '' : `<a href="${URL.common.compressFiles}?sessionId=${this.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&fileName=${fileName}" target="_blank" style="color:#46a6ff">${fileNames}</a>`
    }
  }
}
</script>
<style lang="scss">
</style>

